/**
 * KeyboardShortcutsDialog — reference overlay listing app-wide shortcuts.
 *
 * Triggered from Help › Keyboard Shortcuts and from pressing `?` outside
 * an editable element (parent handles the keypress).
 */
import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';

const sections = [
  {
    title: 'Menus',
    rows: [
      ['Alt + F', 'Open File menu'],
      ['Alt + I', 'Open Insert menu'],
      ['Alt + T', 'Open Tools menu'],
      ['Alt + A', 'Open Automate menu'],
      ['Alt + V', 'Open View menu'],
      ['Alt + H', 'Open Help menu'],
      ['Esc', 'Close any open menu'],
    ],
  },
  {
    title: 'Global',
    rows: [
      ['?', 'Open this shortcuts dialog'],
      ['Ctrl/⌘ + F', 'Open global search'],
    ],
  },
];

const KeyboardShortcutsDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Keyboard shortcuts</DialogTitle>
    <DialogContent>
      {sections.map((section, idx) => (
        <Box key={section.title} sx={{ mb: idx === sections.length - 1 ? 0 : 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            {section.title}
          </Typography>
          <Table size="small">
            <TableBody>
              {section.rows.map(([keys, label]) => (
                <TableRow key={keys}>
                  <TableCell sx={{ width: 160, fontFamily: 'monospace' }}>
                    {keys}
                  </TableCell>
                  <TableCell>{label}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {idx !== sections.length - 1 && <Divider sx={{ mt: 2 }} />}
        </Box>
      ))}
    </DialogContent>
  </Dialog>
);

export default KeyboardShortcutsDialog;
